import axios from 'axios'

/**
 * Check if an error is an Axios 402 (Payment Required / Insufficient Credits) response.
 */
export function isInsufficientCreditsError(error: unknown): boolean {
  return axios.isAxiosError(error) && error.response?.status === 402
}
